import { useState } from "react";
import { observer } from "mobx-react-lite";
import { dataLayerPush } from "core/lib/analytics-methods";
import { Programme } from "core/types";
import dateWrapper from "core/lib/date-wrapper";
import PopupContent from "components/shared/popup-content";
import { PopupComponent } from "components/popup/popup";
import { GridRowProps, OtherDayGridRowItemProps } from "./types";
import { getOtherDayRowItem, getSameDayRowItem } from "./lib";

const OtherDayGridRowItem = observer<OtherDayGridRowItemProps>((props) => {
  const { isRegularDay, isLeft, isRight, style } = props;

  const shouldShow = isRegularDay || isLeft || isRight;

  if (!shouldShow) {
    return null;
  }

  return (
    <li
      className="grid-block h-0-m-30 loading"
      style={style}
    ></li>
  );
});

//Need to be observer?
const GridRow = observer<GridRowProps>((props) => {
  const [popupState, setPopupState] = useState(false);
  // const [programmeArr, setProgrammeArr] = useState<Programme[]>([]);
  const [popupInfo, setPopupInfo] = useState<any>(undefined);
  const [fillArr,] = useState(() => {
    const initArr = Array.from({ length: 48 }, (_, i) => i);
    return initArr;
  });

  const { timeWindow, rowTop, channelNumber } = props;

  const popupCallback = () => {
    setPopupInfo(undefined);
    setPopupState(false);
  }

  const programmeArr: Programme[] = props.programmeArr;

  const ymd = dateWrapper(props.dateItem).yearMonthDay();

  const sameDayProgs = props.timeChunkWidth && programmeArr
    ? programmeArr.filter(x => x.id && ymd === dateWrapper(x.startTime).yearMonthDay())
    : [];

  // eslint-disable-next-line no-constant-condition
  if (!sameDayProgs?.length) {
    const items = timeWindow
      ? fillArr.map((_, ix) => getOtherDayRowItem(ix, props))
      : null;

    return (
      <ul style={{ top: `${rowTop}px` }}>
        {items?.length && items?.map(x => <OtherDayGridRowItem {...x} {...props} />)}
      </ul>
    );
  }

  const dayItems = sameDayProgs
    .map((p, ix) => getSameDayRowItem(ix, p, props));

  return (
    <ul style={{ top: `${rowTop}px` }} data-channel={channelNumber}>
      {dayItems.map((itemProps) => {
        if (!itemProps) {
          return null;
        }

        const { analytics, cssClass, show, style, isActive, showStartTime } = itemProps;

        return (
          <li
            className={cssClass}
            style={style}
            key={show.id}
          >
            <p
              className="grid-block-inner-text"
              {...analytics}
              onClick={() => {
                dataLayerPush("popup-open-user", [
                  show.title,
                  show.startTime,
                  new Date()
                ]);

                setPopupState(true);
                setPopupInfo({
                  id: show.uniqueEventID,
                  current: isActive
                });
              }}
            >
              {show.title} <span className="icon-info"></span>
            </p>
            <p>{show.startTime && showStartTime}</p>
          </li>
        );
      })}

      <PopupComponent showPopup={popupState} popupCallback={popupCallback}>
        <PopupContent
          popupInfo={popupInfo}
          channelNumber={channelNumber}
          popupCallback={popupCallback} />
      </PopupComponent>
    </ul>
  );
});

export default GridRow;
